import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Select, Button,Radio,message,Tooltip, Divider} from 'antd';
 import {dbFields}  from '../../model/group/column';
import { route } from "../../routes/routes";
import { createGroup, getGroupList ,getGroup} from "../../model/group/requests";
import storage from '../../utils/storage';
import { configs } from '../../config/config';


export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};
const Option = Select.Option;
export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

class GroupCreate extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data: {
                type: null,
                name:null
            },
            groupList: [],
            customList:[],
            hiddenCustom:true,
        }
    };
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            message.error("token expired")
            this.props.history.push("/")
        }
    }

    handlerSubmit=(e)=>{
        let  name = this.formRef.current.getFieldValue(dbFields.name.key);
        let parent_id = this.formRef.current.getFieldValue(dbFields.parent.key) ? this.formRef.current.getFieldValue(dbFields.parent.key) : 0;
        createGroup({name:name,parent_id:parent_id}).then(res=>{
            if(res.data.code == 200){
                message.success(configs.http.responseMsg.created)
                setTimeout(()=>{
                    this.props.history.push(route.group.index)
                },1000)
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    };

    componentDidMount(){
        let groupList = [];
        getGroupList().then(res=>{
            if(res.data.code == 200){
                groupList = res.data.data
                this.setState({
                    groupList:groupList
                })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerLoadCustom = (items) => {
        this.setState({
            hiddenCustom:true
        })
        let groupId = items
        if (groupId === 0){
            this.setState({
                hiddenCustom:true
            })
            return false;
        }
        let customList = [];
        getGroup({id:groupId}).then(res=>{
            if(res.data.code == 200){
                customList = res.data.data.customs
                if (customList.length > 0) {
                    this.setState({
                        customList:customList,
                        hiddenCustom:false
                    })
                }else{
                    this.setState({
                        customList:[],
                        hiddenCustom:true
                    })
                }

            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    render() {
        const {groupList,customList} = this.state
        return (
            <>
                <BreadcrumbCustomer   first='Group' second='Create' />
                <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                    initialValues={{
                        remember: false,
                    }}
                >
                        <Form.Item
                            name= {dbFields.name.key}
                            label={dbFields.name.title}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item label={dbFields.parent.title} name={dbFields.parent.key}
                    >
                        <Select
                            onChange={this.handlerLoadCustom}
                        >
                            <Option key={0} value={0}>No Parent</Option>
                            {groupList.length > 0  && groupList.map((items) => {
                                return (<Option key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>
                    </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                            type="primary" 
                            style={{background: "#851dd6",color:"white" }}
                            onClick = {this.handlerSubmit}
                            >
                                Submit
                            </Button>
                        </Form.Item>    
                </Form>    
            </>
        );
    }
}

export default GroupCreate;